import type { AnalyticsField } from '@/shared/analytics/AnalyticsTypes';
import type { MegaGridGroupByPill } from '@/design/MegaGrid/MegaGridTypes';

/**
 * The definitive set of dimensions the adoption drivers grid can group by,
 * surfaced as MegaGrid group-by pills. Each maps a grid column key to the
 * telemetry {@link AnalyticsField} the real breakdown query groups on. Order
 * here is pill order in the grid toolbar.
 */
export interface AdoptionDimension extends MegaGridGroupByPill {
    field: AnalyticsField;
}

export const ADOPTION_DIMENSIONS: AdoptionDimension[] = [
    { columnKey: 'department', label: 'Department', field: 'user_department' },
    { columnKey: 'role', label: 'Role', field: 'user_title' },
    { columnKey: 'orgUnit', label: 'Org Unit', field: 'user_org_unit' },
    { columnKey: 'manager', label: 'Manager', field: 'user_manager' },
    { columnKey: 'task', label: 'Task', field: 'task_category' },
    { columnKey: 'provider', label: 'Provider', field: 'provider_connection_id' },
    { columnKey: 'model', label: 'Model', field: 'model' },
];

/** The group-by pill list handed to MegaGrid (label + column key only). */
export const ADOPTION_GROUP_PILLS: MegaGridGroupByPill[] = ADOPTION_DIMENSIONS.map((d) => ({ columnKey: d.columnKey, label: d.label }));
